import { sanitizeUrl } from '@braintree/sanitize-url';

const sanitizeRedirectUrl = (url: string): string => {
  const normalizedUrl = sanitizeUrl(url);

  if (!normalizedUrl.startsWith('/')) {
    return '';
  }

  return normalizedUrl;
};

const getQueryFromHash = (): string => {
  const hash = window.location.hash;
  const queryIndex = hash.indexOf('?');
  return queryIndex !== -1 ? hash.substring(queryIndex) : '';
};

const qryStringtoObject = (query: string): Record<string, string> => {
  const result: Record<string, string> = {};
  query
    .replace('?', '')
    .split('&')
    .forEach((part) => {
      const [key, value] = part.split('=');
      if (value != null) {
        if (key === 'redirectUrl') {
          const url = sanitizeRedirectUrl(decodeURIComponent(value));
          result[key] = url;
        } else {
          result[key] = decodeURIComponent(value);
        }
      }
    });
  return result;
};

export const toggleButton = () => {
  const btn = document.getElementById('try-again-btn');
  if (btn == null) {
    return null;
  }

  const query = window.location.search || getQueryFromHash();
  const hasRedirectUrl = query.match(/redirectUrl/);

  if (hasRedirectUrl) {
    btn.addEventListener('click', function () {
      const redirectUrl = qryStringtoObject(query).redirectUrl;
      if (redirectUrl) {
        window.location.assign(redirectUrl);
      }
    });
  } else {
    btn.remove();
  }
};
